module.exports = __webpack_public_path__ + "img/sa.6fb5af37.svg";